import React, { Component } from 'react'
import superagent from 'superagent';
import createReactClass from 'create-react-class'

import { Router, Route, Link, IndexRoute, IndexLink, hashHistory, browserHistory } from 'react-router'

import MasterPage from './components/pages/MasterPage';
import { Logged, LoggedUserName, LoggedUserEmail, LoggedUserLekce } from './components/login/Login';
import Kalendar from './components/kalendar/Kalendar';
import {UserDetail} from './components/login/UserDetail';
import Users from './components/users/Users';
import LekceList from './components/lekce/Lekce';
import Statistiky from './components/statistiky/Statistiky';


const NotFound = () => <h1>404.. This page is not found!</h1>

export class App extends React.Component {

  constructor() {
    super();
    this.state = {
      userID: 0,
      userName: '',
      turnaj: '',
      kredit: LoggedUserLekce(),
    };

    this.setUser = this.setUser.bind(this);
    this.addKredit = this.addKredit.bind(this);
  }

  setUser = function(userID, userName) {
    this.setState({userID: userID, userName: userName, kredit: LoggedUserLekce()});
    if (userID == 0) {
      browserHistory.push('/');
      window.location.reload();
    }
  };

  addKredit = function(pocet) {
    this.setState({kredit: 1*this.state.kredit + 1*pocet});
  }

  getLekceStr(lekce) {
    var lekceStr = '';
    switch(lekce) {
      case '':
        lekceStr = 'nemáte žádný kredit'
        //pocetStyle = 'table-danger'
        break;
      case '1':
        lekceStr = ' lekce'
        break;
      case '2':
        lekceStr = ' lekce'
        break;
      case '3':
        lekceStr = ' lekce'
        break;
      case '4':
        lekceStr = ' lekce'
        break;
      default:
        lekceStr = ' lekcí'
        break;
    }
    return lekceStr;
  }

  render () {
    if (!Logged()) {
      return (<MasterPage setUser={this.setUser} />);
    }

    //var lekce = LoggedUserLekce();
    var lekceStr = this.getLekceStr(this.state.kredit)

    const Container = (props) => <div>
      <MasterPage setUser={this.setUser} kredit={this.state.kredit} />
      <div style={{paddingLeft: '0px', paddingTop: '0px'}}>
        {props.children}
      </div>
    </div>

    const Home = (props) => <Kalendar addKredit={this.addKredit} />
    const UserDetailEl = (props) => <UserDetail setUser={this.setUser} />
    const UserListEl = (props) => <Users />
    const LekceListEl = (props) => <LekceList />
    const StatistikyEl = (props) => <Statistiky />

    return (
      <Router history={hashHistory}>
        <Route path='/' component={Container}>
          <IndexRoute component={Home} />
          <Route path='user-detail' component={UserDetailEl} />
          <Route path='users-list' component={UserListEl} />
          <Route path='lekce' component={LekceListEl} />
          <Route path='statistiky' component={StatistikyEl} />
          <Route path='*' component={NotFound} />
        </Route>
      </Router>
    )
  }
}



// WEBPACK FOOTER //
// src/AppRoot.jsx